import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "ApiClient";
import { ApiURL } from "utils/Actions";
import { API_RESPONSE_STATUS } from "utils/Constants";
import { showErrorModal } from "utils/hooks/handleNotification";
import { CommentType } from "utils/Types";
import { common } from "utils/Wording";

type CommentSliceType = {
  data: CommentType[];
  isLoading: boolean;
  isLoadingError: boolean;
};

const CommentInit: CommentSliceType = {
  data: [] as CommentType[],
  isLoading: false,
  isLoadingError: false
};

export const fetchComment = createAsyncThunk(ApiURL.comment, async (refNum: number) => {
  if (!refNum) {
    throw new Error(common.loadingError);
  }

  try {
    const res = await api.get(`${ApiURL.comment}/${String(refNum)}`);
    if (res?.data?.status === API_RESPONSE_STATUS.ERROR) {
      throw new Error(common.loadingError);
    }
    const data = res?.data?.data ? res.data.data : [];
    return data;
  } catch (error: any) {
    showErrorModal({
      title: common.failAsync,
      errors: error.response?.data?.errors ? error.response.data.errors : [error.message]
    });
    return CommentInit.data;
  }
});

export const CommentSlice = createSlice({
  name: "comment",
  initialState: CommentInit,
  reducers: {
    setComment: (state, action) => {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoadingError: false
      };
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchComment.pending, state => {
      state.isLoading = true;
      state.isLoadingError = false;
    });
    builder.addCase(fetchComment.fulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoadingError: false
      };
    }),
      builder.addCase(fetchComment.rejected, () => {
        return {
          data: CommentInit.data,
          isLoading: false,
          isLoadingError: true
        };
      });
  }
});

export const { setComment } = CommentSlice.actions;

export default CommentSlice.reducer;
